import { NO_PITCH } from '../../gregorio-chant/constants';
import { GregorioHepisemaAdjustment, GregorioHepisemaVbasepos } from './enums';


export class GregorioStruct {
  hepisema_adjustments: GregorioHepisemaAdjustment[] = [
    {
      vbasepos: GregorioHepisemaVbasepos.HVB_AUTO,
      nudge: null,
      pitch_extremum: null,
    }
  ];

  texverbs: string[] = [];

  gregorio_add_hepisema_adjustment(vbasepos: GregorioHepisemaVbasepos, nudge: string): number {
    this.hepisema_adjustments.push({
      vbasepos: vbasepos,
      nudge: nudge,
      pitch_extremum: NO_PITCH,
    });

    return this.hepisema_adjustments.length;
  }

  gregorio_get_hepisema_adjustment(index: number): GregorioHepisemaAdjustment | undefined {
    if (index >= this.hepisema_adjustments.length) {
      // throw new Error('array index out of bounds');
      return;
    }
    return this.hepisema_adjustments[index];
  }
}
